<template>
  <div id="dashboard-deposit-withdrawal">
    <v-card
      class="px-5 py-2 mt-4 mb-0 elevation-0"
      :class="{ 'sticky-filters': user.preferences.stickyFilters }"
    >
      <CommonFilters type="depositWithdrawal" :hide="['type']" @filterElements="filterElements" />
    </v-card>

    <v-row>
      <v-col cols="12" lg="12" md="12" class="mt-4 py-0">
        <OrdersByMonth ref="depositByMonth" type="deposit" />
      </v-col>
      <v-col cols="12" lg="12" md="12" class="mt-4 py-0">
        <OrdersByMonth ref="withdrawalByMonth" type="withdrawal" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CommonFilters from '@/views/components/common/CommonFilters'
import OrdersByMonth from '@/views/components/dashboardDetail/orders/OrdersByMonth'

export default {
  components: {
    CommonFilters,
    OrdersByMonth,
  },
  computed: {
    ...mapState(['user']),
  },
  methods: {
    async filterElements(filters) {
      this.loading = true
      try {
        if (this.$refs.depositByMonth) this.$refs.depositByMonth.loadSummary(filters)
        if (this.$refs.withdrawalByMonth) this.$refs.withdrawalByMonth.loadSummary(filters)
      } catch (error) {
        this.$root.$snackbar.checkAndOpenCommonLoadError(error)
      }
      this.loading = false
    },
  },
}
</script>
